import isPlainObject from 'lodash-es/isPlainObject';
import { getRequiredStringValue, getRequiredValue } from './ConfigurationHelpers';
export function parseProductConfig(config) {
    if (isPlainObject(config)) {
        const productConfig = getRequiredValue('products', config);
        if (isPlainObject(productConfig)) {
            const platform = getRequiredStringValue('platform', productConfig);
            const studio = getRequiredStringValue('studio', productConfig);
            const docs = getRequiredStringValue('docs', productConfig);
            const mattermost = getRequiredStringValue('mattermost', productConfig);
            return {
                platform,
                studio,
                docs,
                mattermost,
            };
        }
    }
    throw new Error('An error occurred parsing product configuration');
}
//# sourceMappingURL=ProductConfiguration.js.map